import React from "react";
import { Button, Table, Tag } from "antd";

import AuditEntryDetails from "./AuditEntryDetails";
import {
  ATTRIBUTIONS,
  CATEGORIES,
  actionLabel,
  actorLabel,
  fieldLabel,
  formatDate,
  targetLabel,
} from "./labels";

// Tableau d'entrées du journal (écran Journal et historique d'un envoi)
export default function AuditTable({
  entries,
  loading,
  hasMore,
  onLoadMore,
  companyNames = {},
  showCompany = true,
  onShowOperation,
}) {
  const columns = [
    { title: "Date", dataIndex: "at", width: 160, render: (at) => formatDate(at) },
    {
      title: "Catégorie",
      dataIndex: "category",
      width: 100,
      render: (category) => {
        const c = CATEGORIES[category] || { label: category, color: "default" };
        return <Tag color={c.color}>{c.label}</Tag>;
      },
    },
    { title: "Action", dataIndex: "action", render: (action) => actionLabel(action) },
    {
      title: "Auteur",
      dataIndex: "actor",
      render: (actor, entry) => {
        const attribution = entry.source && entry.source.attribution;
        return (
          <>
            {actorLabel(actor)}
            {attribution === "none" && (
              <Tag color={ATTRIBUTIONS.none.color} style={{ marginLeft: 6 }}>
                {ATTRIBUTIONS.none.label}
              </Tag>
            )}
          </>
        );
      },
    },
    {
      title: "Cible",
      dataIndex: "target",
      render: (target) => (
        <>
          {targetLabel(target)}
          {showCompany && target && target.company_id && (
            <div style={{ opacity: 0.65, fontSize: 12 }}>
              {companyNames[target.company_id] || target.company_id}
            </div>
          )}
        </>
      ),
    },
    {
      title: "Champs",
      dataIndex: "fields",
      render: (fields) => (fields || []).map((field) => fieldLabel(field)).join(", "),
    },
  ];

  return (
    <>
      <Table
        size="small"
        bordered
        rowKey="id"
        loading={loading}
        columns={columns}
        dataSource={entries}
        pagination={false}
        scroll={{ x: true }}
        locale={{ emptyText: "Aucune entrée" }}
        expandable={{
          expandedRowRender: (entry) => (
            <AuditEntryDetails entry={entry} onShowOperation={onShowOperation} />
          ),
        }}
      />
      {hasMore && (
        <div style={{ textAlign: "center", marginTop: 12 }}>
          <Button onClick={onLoadMore} loading={loading}>
            Charger plus
          </Button>
        </div>
      )}
    </>
  );
}
